<template>
    <div>
        <div class="flip-cards">
            <div class="flip-card-editor" v-for="card in data.cards">
                <div class="flip-card" :class="{'flipped': !card.attributes.flipped}">
                    <div class="flip-container">
                        <div class="card-front">
                            <template v-if="card.content.front.attributes.type">
                                <div class="text-editor" v-if="card.content.front.attributes.type === 'text'" :style="{'font-size': card.content.front.attributes.size + 'px'}">
                                    <contenteditable tag="div" v-model="card.content.front.data" class="input-div"/>
                                </div>
                                <div class="photo-editor" v-if="card.content.front.attributes.type === 'photo'">
                                    <div v-if="card.content.front.data" class="card-photo">
                                        <img :src="card.content.front.data"/>
                                    </div>
                                    <b-button v-else @click="openMediaPicker(card.content.front)"><i class="fad fa-image mr-2"></i>Choose Photo</b-button>
                                </div>
                            </template>
                            <template v-else>
                                <b-button @click="card.content.front.attributes.type = 'text'"><i class="fad fa-text"></i></b-button>
                                <b-button @click="card.content.front.attributes.type = 'photo'"><i class="fad fa-image"></i></b-button>
                            </template>
                        </div>
                        <div class="card-back">
                            <template v-if="card.content.back.attributes.type">
                                <div class="text-editor" v-if="card.content.back.attributes.type === 'text'" :style="{'font-size': card.content.back.attributes.size + 'px'}">
                                    <contenteditable tag="div" v-model="card.content.back.data" class="input-div"/>
                                </div>
                                <div class="photo-editor" v-if="card.content.back.attributes.type === 'photo'">
                                    <div v-if="card.content.back.data" class="card-photo">
                                        <img :src="card.content.back.data"/>
                                    </div>
                                    <b-button v-else @click="openMediaPicker(card.content.back)"><i class="fad fa-image mr-2"></i>Choose Photo</b-button>
                                </div>
                            </template>
                            <template v-else>
                                <b-button @click="card.content.back.attributes.type = 'text'"><i class="fad fa-text"></i></b-button>
                                <b-button @click="card.content.back.attributes.type = 'photo'"><i class="fad fa-image"></i></b-button>
                            </template>
                        </div>
                    </div>
                </div>
                <div class="flip-card-controls mt-3 ml-2">
                    <b-button size="is-small" @click="flipCard(card)" class="mr-2"><i class="far fa-refresh mr-2"></i>Flip to {{(card.attributes.flipped) ? 'Front' : 'Back'}}</b-button>
                    <b-button size="is-small" @click="removeCard(card)" class="mr-2"><i class="far fa-trash-alt"></i></b-button>
                    <b-select size="is-small" inline v-model="card.content.back.attributes.size" v-if="!card.attributes.flipped">
                        <option value="10">10</option>
                        <option value="11">11</option>
                        <option value="12">12</option>
                        <option value="13">13</option>
                        <option value="14">14</option>
                        <option value="15">15</option>
                        <option value="16">16</option>
                        <option value="18">18</option>
                        <option value="20">20</option>
                        <option value="22">22</option>
                        <option value="24">24</option>
                        <option value="30">30</option>
                    </b-select>
                    <b-select size="is-small" inline v-model="card.content.front.attributes.size" v-if="card.attributes.flipped">
                        <option value="10">10</option>
                        <option value="11">11</option>
                        <option value="12">12</option>
                        <option value="13">13</option>
                        <option value="14">14</option>
                        <option value="15">15</option>
                        <option value="16">16</option>
                        <option value="18">18</option>
                        <option value="20">20</option>
                        <option value="22">22</option>
                        <option value="24">24</option>
                        <option value="26">26</option>
                        <option value="30">30</option>
                    </b-select>
                </div>
            </div>

            <div class="is-clearfix"></div>
            <hr/>
            <div class="mb-5 ml-2">
                <b-button @click="addCard"><i class="fas fa-plus mr-2"></i>Add Card</b-button>
            </div>

            <media-picker class="library" type="PHOTO" @choose="chooseMedia" @close="mediaPicker=false" v-if="mediaPicker"></media-picker>
        </div>
    </div>
</template>

<script>
    import MediaPicker from "../../../cards/media_library/MediaPicker.vue";

    export default {
        props: ['data'],
        components: {MediaPicker},
        data: function() {
            return {
                mediaTarget: null,
                mediaPicker: false
            };
        },
        methods: {
            addCard() {
                this.data.cards.push({
                    content: {
                        front: {
                            data: '',
                            attributes: {
                                type: null,
                                size: 22
                            }
                        }, back: {
                            data: '',
                            attributes: {
                                type: null,
                                size: 22
                            }
                        }
                    },
                    attributes: {
                        flipped: false
                    }
                });
            },
            removeCard(card) {
                this.data.cards.splice(this.data.cards.indexOf(card), 1);
            },
            flipCard(card) {
                card.attributes.flipped = !card.attributes.flipped;
            },
            openMediaPicker: function(target) {
                this.mediaTarget = target;
                this.mediaPicker = true;
            },
            chooseMedia: function(media) {
                this.mediaPicker = false;
                this.mediaTarget.data = media.square;
            }
        },
        created() {
            if (!this.data.cards) {
                this.data.cards = [];
            }
        }
    };
</script>

<style lang="scss">
    .flip-cards {
        margin: 0 1.3rem 0 1.3rem;

        .flip-card-editor {
            margin: 0.6rem 1rem 0 0;
            float: left;

        }

        .flip-card {
            border-radius: 5px;
            padding: 10px;

            width: 260px;
            height: 260px;
            overflow: hidden;

            perspective: 1000px; /* Remove this if you don't want the 3D effect */

            .flip-container {
                position: relative;
                width: 100%;
                height: 100%;
                text-align: center;
                transition: transform 0.6s;
                transform-style: preserve-3d;
                box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
                border: 1px solid #e7e7e7;
            }

            &.flipped .flip-container {
                transform: rotateY(180deg);
            }

            .card-front, .card-back {
                position: absolute;
                width: 100%;
                height: 100%;
                -webkit-backface-visibility: hidden; /* Safari */
                backface-visibility: hidden;
                display: flex;

                .text-editor {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding: 18px;
                    width: 100%;
                    overflow: hidden;


                    .input-div {
                        width: 100%;

                        &:focus {
                            outline: none;
                        }
                    }
                }
            }

            .card-front {
                background-color: white;
                color: black;
            }

            .card-back {
                background-color: white;
                transform: rotateY(180deg);
            }

            textarea {
                text-align: center;
            }

            .card-photo {
                img {
                    padding: 0;
                    margin: 0;
                    width: 100%;
                    height: 100%;
                }
            }
        }
    }

</style>
